/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.CertificationChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getCertificationMetadataRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.CertificationChirpService',
  rpcName: 'getCertificationMetadata',
  auth: 'app',
  fingerprint: 'YDnonTDSyg8fQH4rK9j7yZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};